import { Component, EventEmitter, inject, Injector } from "@angular/core";
import { Observable } from "rxjs";
import { AppComponentBase } from "@shared/app-component-base";
import { finalize } from "rxjs";
import { FuseSidebarService } from "@fuse/components/sidebar/sidebar.service";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { FuseConfirmationService } from "@nx-workspace/fuse";

export enum DialogClosingResult {
    Proceed = 1,
    Cancel = 1,
}

export class SaveOperationResult {
    closeDialog: boolean;
    dialogResult?: any;

    constructor(closeDialog: boolean, dialogResult: any) {
        this.closeDialog = closeDialog;
        this.dialogResult = dialogResult;
    }
}

@Component({
    template: "",
})
export abstract class BaseDialogComponent<T, SaveType = any> extends AppComponentBase {
    protected _fuseConfirmationService = inject(FuseConfirmationService);

    _matDialog: MatDialog;

    onSaving: EventEmitter<boolean> = new EventEmitter<boolean>();

    protected _fuseSidebarService: FuseSidebarService;

    protected constructor(injector: Injector, public _dialogRef: MatDialogRef<T>) {
        super(injector);
        this._matDialog = injector.get(MatDialog);
        this.disableClose = true;
        this._fuseSidebarService = injector.get(FuseSidebarService);
    }

    set disableClose(disable: boolean) {
        this._dialogRef.disableClose = disable;
    }

    ngOnInit(): void {}

    hasPendingChanges() {
        return false;
    }

    public close(dialogResult?: any) {
        if (this.hasPendingChanges()) {
            this.onClosing(dialogResult);
        } else {
            this._dialogRef.close(dialogResult);
        }
    }

    protected onClosing(dialogResult?: any) {
        this._fuseConfirmationService
            .open({
                title: "Confirmar alterações",
                message: "Você deseja salvar as alterações feitas neste item de trabalho?",
                actions: {
                    confirm: {
                        show: true,
                        label: this.l("Dialog.ConfirmChanges.Action.SaveChanges.Title"),
                        color: "primary",
                    },
                    discard: {
                        show: true,
                        label: this.l("Dialog.ConfirmChanges.Action.DiscardChanges.Title"),
                        color: "warn",
                    },
                    cancel: {
                        show: true,
                        label: this.l("Action.Cancel"),
                    },
                },
                dismissible: false,
            })
            .afterClosed()
            .subscribe((result) => {
                if (result === "confirmed") {
                    this.onSave().subscribe((result) => {
                        if (result.closeDialog) {
                            this._dialogRef.close(result.dialogResult);
                        }
                    });
                } else if (result === "discard") {
                    this._dialogRef.close();
                }
            });
    }

    public save(params?: SaveType) {
        this.onSaving.emit(true);
        this.onSave(params)
            .pipe(
                finalize(() => {
                    this.onSaving.emit(false);
                })
            )
            .subscribe((result) => {
                if (result.closeDialog) {
                    this._dialogRef.close(result.dialogResult);
                }
            });
    }

    public onSave(params?: SaveType): Observable<SaveOperationResult> {
        return new Observable<SaveOperationResult>((observer) => {
            observer.next(new SaveOperationResult(true, {}));
            observer.complete();
        });
    }

    public toggleChat() {
        this._fuseSidebarService.getSidebar("chatPanel").unfoldTemporarily();
    }
}
